import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { rawRoutes } from '@/router/routes';
import { flattenRoutes, transformFlatRoutesToPathMap } from '@/router/helpers';

const initialFlatRoutes = flattenRoutes(rawRoutes);
const initialPathRouteMap = transformFlatRoutesToPathMap(initialFlatRoutes);

export const useRouteStore = create()(
  devtools(
    set => {
      return {
        currentRoute: null,
        flatRoutes: initialFlatRoutes,
        pathRouteMap: initialPathRouteMap,
        setCurrentRoute: currentRoute => set({ currentRoute }),
        setFlatRoutes: flatRoutes => set({ flatRoutes }),
        setPathRouteMap: pathRouteMap => set({ pathRouteMap }),
      };
    },
    { name: 'routeStore' }
  )
);
